import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@fpsm/cxy-components/Button';
import { Input } from '@fpsm/cxy-components/Input';
import { useFetcher } from '@remix-run/react';

import { type Repub, REPUBS } from '@cx-modules/constants';

import { type AuthResponse } from '../../types';

import styles from './styles/ForgotPasswordForm.module.css';

export const ForgotPasswordForm = ({ repub }: {repub: Repub;}) => {
  const fetcher = useFetcher<AuthResponse>();
  const [showErrorState, setShowErrorState] = useState(false);

  const { t } = useTranslation(['label']);

  const data = fetcher.data;
  const hasErrorMessage = data?.message && !data?.success;

  useEffect(() => {
    if (data?.fieldErrors || hasErrorMessage) {
      setShowErrorState(true);
    }
  }, [data?.fieldErrors, hasErrorMessage]);

  const onChange = () => {
    setShowErrorState(false);
  };

  return (
    <fetcher.Form
      action={`${repub !== REPUBS.OC.name ? `/${repub.toLowerCase()}` : ''}/plus/auth/forgot-password`}
      className={styles.forgotPasswordForm}
      method="post">

			<p className={styles.helperText}>
				{t('CX_AUTH_FORGOT_PASSWORD_INSTRUCTIONS')}
			</p>
			<Input
        errors={showErrorState ? [data?.fieldErrors?.email] : undefined}
        id="email"
        name="email"
        onChange={onChange}
        placeholder="Email"
        type="email" />

			{data?.message &&
      <p className={`mt-2${hasErrorMessage ? ' text-red-300' : ''}`}>
					{data.message}
				</p>
      }

			<div className={styles.buttonSection}>
				<Button isLoading={fetcher.state !== 'idle'} size="large" type="submit">
					{t('CX_AUTH_RESET_PASSWORD')}
				</Button>
			</div>
		</fetcher.Form>);

};